import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Paper, Typography, CircularProgress, TextField, MenuItem, InputAdornment } from '@mui/material';
import ApiService from "../../functions/apiService";
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { Col, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import './payroll.css'
import Modal from 'react-bootstrap/Modal';
import SearchIcon from "@mui/icons-material/Search";
import MyTable from '../../components/Schedule/MyTable';
import EmptyState from '../../components/Error/EmptyState';
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

const ManagePayroll = () => {
    const [payrollData, setPayrollData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedCode, setSelectedCode] = useState("add-payroll");
    const [searchResult, setSearchResult] = useState('');
    const [code, setCode] = useState("");
    const [value, setValue] = useState("");
    const [description, setDescription] = useState("");
    const [condition, setCondition] = useState("");
    const [sort, setSort] = useState("");
    const [show, setShow] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showCopyModal, setShowCopyModal] = useState(false);
    const [selectedEditRecord, setSelectedEditRecord] = useState([]);
    const [selectedCopyRecord, setSelectedCopyRecord] = useState([]);
    const [deletModal, setDeleteModal] = useState(false)
    const [selectedRecord, setSelectedRecord] = useState(null);

    const handleClose = () => {
        setShow(false)
        setCode("");
        setValue("");
        setDescription("");
        setCondition("");
        setSort("");
    };
    const handleShow = () => setShow(true);

    const getPayrollData = async () => {
        setLoading(true);
        try {
            const endpoint = selectedCode === "add-payroll" ? "/payroll/add-payroll" : "/payroll/pay-code";
            const response = await ApiService.get(endpoint);
            setPayrollData(response.data)
        } catch (error) {
            console.error(error.data)
        }
        finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        getPayrollData()
    }, [selectedCode])

    const handleCreatePayroll = async () => {
        setLoading(true);
        try {
            const response = await ApiService.post('/payroll/add', {
                SO_Code: code,
                SO_Value: value,
                SO_Desc: description,
                SO_Condition: condition,
                SO_Sort: sort
            });
            toast.success(response.message)
            getPayrollData()
            handleClose()
        } catch (error) {
            toast.error(error.data.message)
        }
        finally {
            setLoading(false)
        }
    }

    const filteredData = useMemo(() => {
        return payrollData.filter((item) =>
            String(item.SO_Code).toLowerCase().includes(searchResult.toLowerCase()) ||
            String(item.SO_Value).toLowerCase().includes(searchResult.toLowerCase()) ||
            String(item.SO_Desc).toLowerCase().includes(searchResult.toLowerCase()) ||
            String(item.SO_Condition).toLowerCase().includes(searchResult.toLowerCase()) ||
            String(item.SO_Sort).toLowerCase().includes(searchResult.toLowerCase())
        );
    }, [payrollData, searchResult]);

    const handleEditClick = (record) => {
        setSelectedEditRecord(record);
        setShowEditModal(true);
    };
    const handleCopyClick = (record) => {
        setSelectedCopyRecord(record);
        setShowCopyModal(true);
    };

    const handleEditRecord = async (record) => {
        const updatedRecord = { SO_Code: record.SO_Code, SO_Value: record.SO_Value, SO_Desc: record.SO_Desc, SO_Condition: record.SO_Condition, SO_Sort: record.SO_Sort };
        try {
            const response = await ApiService.post('/payroll/edit/update', updatedRecord);
            toast.success(response.message)
            getPayrollData()
            setShowEditModal(false);
        } catch (error) {
            console.error("Edit API Error:", error);
            toast.error(error.data.message)
        }
    };

    const handleCopyRecord = async (record) => {
        const updatedRecord = { SO_Code: record.SO_Code, SO_Value: record.SO_Value, SO_Desc: record.SO_Desc, SO_Condition: record.SO_Condition, SO_Sort: record.SO_Sort };
        try {
            const response = await ApiService.post('/payroll/add', updatedRecord);
            toast.success(response.message);
            getPayrollData();
            setShowCopyModal(false);
        } catch (error) {
            toast.error(error.data.message)
        }
    };

    const handleDeleteClick = (record) => {
        setSelectedRecord(record);
        setDeleteModal(true);
    };

    const handleDelete = async () => {
        if (!selectedRecord) return;
        try {
            const response = await ApiService.post('/payroll/delete', {
                SO_Code: selectedRecord.SO_Code,
                SO_Value: selectedRecord.SO_Value
            });
            toast.success(response.message)
            getPayrollData()
            setDeleteModal(false);
        } catch (error) {
            toast.error(error.data.message)
        }
    };



    const columns = [
        {
            field: 'code', headerName: 'Code', flex: 1, minWidth: 150, sortable: false,
            valueGetter: (params) => params.row.SO_Code
        },
        {
            field: 'value', headerName: 'Value', flex: 1, minWidth: 150, sortable: false,
            valueGetter: (params) => params.row.SO_Value
        },
        {
            field: 'description', headerName: 'Description', flex: 1, minWidth: 200, sortable: false,
            valueGetter: (params) => params.row.SO_Desc
        },
        {
            field: 'condition', headerName: 'Condition', flex: 1, minWidth: 200, sortable: false,
            valueGetter: (params) => params.row.SO_Condition
        },
        {
            field: 'sort', headerName: 'Sort', flex: 1, minWidth: 150, sortable: false,
            valueGetter: (params) => params.row.SO_Sort
        },
        {
            field: 'action', headerName: 'Action', flex: 1, minWidth: 150,
            renderCell: (params) => {
                return (
                    <div style={{ gap: 10, display: 'flex' }}>
                        <img src='/images/edit.svg' style={{ cursor: 'pointer' }}
                            onClick={() => handleEditClick(params.row)} />
                        <img src='/images/copy.svg' style={{ cursor: 'pointer' }}
                            onClick={() => handleCopyClick(params.row)} />
                        <img src='/images/delete.svg' style={{ cursor: 'pointer' }}
                            onClick={() => handleDeleteClick(params.row)} />
                    </div>
                );
            }
        },
    ]

    return (
        <>
            <Paper className="p-4" style={{ marginTop: "1rem" }}>
                <div>
                    <Grid container spacing={0} alignItems="center" justifyContent="space-between">
                        <Grid item xs={3}>
                            <Typography variant="h5">
														<Link to="/firehouse/payroll" style={{ color: "black" }}>
															<ArrowBackIosIcon />
														</Link>Record</Typography>
                        </Grid>
                        <Grid alignItems="center" sx={{ display: 'flex', gap: "8px" }} >
                            <Grid item xs={5}>
                                <TextField
                                    label='Search by Code'
                                    color="secondary"
                                    variant="outlined"
                                    select
                                    size='medium'
                                    InputProps={{
                                        sx: {
                                            width: "230px",
                                            height: '48px',
                                            fontSize: '14px'
                                        }
                                    }}
                                    value={selectedCode}
                                    onChange={(e) => setSelectedCode(e.target.value)}
                                >
                                    <MenuItem value={"add-payroll"}>
                                        ADD_PAYROLL{" "}
                                    </MenuItem>
                                    <MenuItem value={"pay-code"}>
                                        PAY_CODES{" "}
                                    </MenuItem>

                                </TextField>
                            </Grid>
                            <Grid item xs={'auto'}>
                                <TextField
                                    id="outlined-basic"
                                    label=""
                                    placeholder='Search'
                                    variant="outlined"
                                    value={searchResult}
                                    onChange={(e) => setSearchResult(e.target.value)}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                        sx: {
                                            height: '48px',
                                        }
                                    }} />
                            </Grid>
                            <Grid item xs={'auto'}>
                                <ButtonTheme type='submit' variant="filled" color='primary' onClick={handleShow}>
                                    Add New
                                </ButtonTheme>
                                <Modal show={show} onHide={handleClose} size="lg">
                                    <Modal.Header closeButton>
                                        <Modal.Title>Add Record</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <Grid container spacing={1} alignItems="center" justifyContent="space-between">
                                            <Grid item xs={6}>
                                                <label>
                                                    Code
                                                </label>
                                                <TextField
                                                    label='Code'
                                                    className="mt-1 w-100"
                                                    color="secondary"
                                                    variant="outlined"
                                                    select
                                                    size='medium'
                                                    InputProps={{
                                                        sx: {

                                                            height: '48px',
                                                            fontSize: '14px'
                                                        }
                                                    }}
                                                    value={code}
                                                    onChange={(e) => setCode(e.target.value)}
                                                >
                                                    <MenuItem value={"ADD_PAYROLL"}>
                                                        ADD_PAYROLL{" "}
                                                    </MenuItem>
                                                    <MenuItem value={"PAY_CODE"}>
                                                        PAY_CODES{" "}
                                                    </MenuItem>

                                                </TextField>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <label>
                                                    Value
                                                </label>
                                                <TextField
                                                    label='Value'
                                                    className="mt-1 w-100"
                                                    color="secondary"
                                                    variant="outlined"
                                                    InputProps={{
                                                        sx: {
                                                            height: '48px',
                                                            fontSize: '14px'
                                                        }
                                                    }}
                                                    value={value}
                                                    onChange={(e) => setValue(e.target.value)}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <label>
                                                    Description
                                                </label>
                                                <TextField
                                                    label='Description'
                                                    className="mt-1 w-100"
                                                    color="secondary"
                                                    variant="outlined"
                                                    InputProps={{
                                                        sx: {
                                                            height: '48px',
                                                            fontSize: '14px'
                                                        }
                                                    }}
                                                    value={description}
                                                    onChange={(e) => setDescription(e.target.value)}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <label>
                                                    Condition
                                                </label>
                                                <TextField
                                                    label='Condition'
                                                    className="mt-1 w-100"
                                                    color="secondary"
                                                    variant="outlined"
                                                    InputProps={{
                                                        sx: {
                                                            height: '48px',
                                                            fontSize: '14px'
                                                        }
                                                    }}
                                                    value={condition}
                                                    onChange={(e) => setCondition(e.target.value)}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <label>
                                                    Sort
                                                </label>
                                                <TextField
                                                    label='Sort'
                                                    className="mt-1 w-100"
                                                    color="secondary"
                                                    variant="outlined"
                                                    InputProps={{
                                                        sx: {
                                                            height: '48px',
                                                            fontSize: '14px'
                                                        }
                                                    }}
                                                    value={sort}
                                                    onChange={(e) => setSort(e.target.value)}
                                                />
                                            </Grid>
                                        </Grid>
                                        <ButtonTheme type='submit' variant="filled" color='primary' onClick={handleCreatePayroll} className="mt-4">
                                            Create
                                        </ButtonTheme>
                                    </Modal.Body>
                                </Modal>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
                <div className='mt-4'>
                    {loading ? (
                        <div className='d-flex align-items-center justify-content-center' style={{ height: 580 }}>
                            <CircularProgress />
                        </div>
                    ) : (
                        <>
                            {filteredData.length > 0 &&
                                <MyTable
                                    rows={filteredData}
                                    columns={columns}
                                    hideFooter={true}
                                    checkboxSelection={false}
                                />
                            }
                            {filteredData.length == 0 &&
                                <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 580 }}>
                                    <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                                    <span className='mt-4' style={{ color: '#555555' }}>
                                        No Records Found
                                    </span>
                                </div>
                            }
                        </>
                    )}
                </div>
            </Paper >

            <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
                <div className="modal-content">
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Record</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Grid container spacing={1} alignItems="center" justifyContent="space-between">
                            <Grid item xs={6}>
                                <label>Code</label>
                                <TextField
                                    className="mt-1 w-100"
                                    color="secondary"
                                    variant="outlined"
                                    select
                                    size="medium"
                                    InputProps={{ sx: { height: "48px", fontSize: "14px" } }}
                                    value={selectedEditRecord.SO_Code}
                                    readOnly
                                >
                                    <MenuItem value={"ADD_PAYROLL"}>ADD_PAYROLL</MenuItem>
                                    <MenuItem value={"PAY_CODE"}>PAY_CODES</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={6}>
                                <label>Value</label>
                                <TextField
                                    className="mt-1 w-100"
                                    color="secondary"
                                    variant="outlined"
                                    InputProps={{ sx: { height: "48px", fontSize: "14px" } }}
                                    value={selectedEditRecord.SO_Value}
                                    readOnly
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <label>Description</label>
                                <TextField
                                    className="mt-1 w-100"
                                    color="secondary"
                                    variant="outlined"
                                    InputProps={{ sx: { height: "48px", fontSize: "14px" } }}
                                    value={selectedEditRecord.SO_Desc}
                                    onChange={(e) => setSelectedEditRecord({
                                        ...selectedEditRecord,
                                        SO_Desc: e.target.value
                                    })}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <label>Condition</label>
                                <TextField
                                    className="mt-1 w-100"
                                    color="secondary"
                                    variant="outlined"
                                    InputProps={{ sx: { height: "48px", fontSize: "14px" } }}
                                    value={selectedEditRecord.SO_Condition}
                                    onChange={(e) => setSelectedEditRecord({
                                        ...selectedEditRecord,
                                        SO_Condition: e.target.value
                                    })}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <label>Sort</label>
                                <TextField
                                    className="mt-1 w-100"
                                    color="secondary"
                                    variant="outlined"
                                    InputProps={{ sx: { height: "48px", fontSize: "14px" } }}
                                    value={selectedEditRecord.SO_Sort}
                                    onChange={(e) => setSelectedEditRecord({
                                        ...selectedEditRecord,
                                        SO_Sort: e.target.value
                                    })}
                                />
                            </Grid>
                        </Grid>
                        <ButtonTheme type="submit" variant="filled" color="primary" onClick={() => handleEditRecord(selectedEditRecord)} className="mt-4">
                            Update
                        </ButtonTheme>
                    </Modal.Body>
                </div>
            </Modal>

            <Modal show={showCopyModal} onHide={() => setShowCopyModal(false)}>
                <div className="modal-content">
                    <Modal.Header closeButton>
                        <Modal.Title>Copy Record</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Grid container spacing={1} alignItems="center" justifyContent="space-between">
                            <Grid item xs={6}>
                                <label>Code</label>
                                <TextField
                                    className="mt-1 w-100"
                                    color="secondary"
                                    variant="outlined"
                                    select
                                    size="medium"
                                    InputProps={{ sx: { height: "48px", fontSize: "14px" } }}
                                    value={selectedCopyRecord.SO_Code}
                                    onChange={(e) => setSelectedCopyRecord({
                                        ...selectedCopyRecord,
                                        SO_Code: e.target.value
                                    })}
                                >
                                    <MenuItem value={"ADD_PAYROLL"}>ADD_PAYROLL</MenuItem>
                                    <MenuItem value={"PAY_CODE"}>PAY_CODES</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={6}>
                                <label>Value</label>
                                <TextField
                                    className="mt-1 w-100"
                                    color="secondary"
                                    variant="outlined"
                                    InputProps={{ sx: { height: "48px", fontSize: "14px" } }}
                                    value={selectedCopyRecord.SO_Value}
                                    onChange={(e) => setSelectedCopyRecord({
                                        ...selectedCopyRecord,
                                        SO_Value: e.target.value
                                    })}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <label>Description</label>
                                <TextField
                                    className="mt-1 w-100"
                                    color="secondary"
                                    variant="outlined"
                                    InputProps={{ sx: { height: "48px", fontSize: "14px" } }}
                                    value={selectedCopyRecord.SO_Desc}
                                    onChange={(e) => setSelectedCopyRecord({
                                        ...selectedCopyRecord,
                                        SO_Desc: e.target.value
                                    })}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <label>Condition</label>
                                <TextField
                                    className="mt-1 w-100"
                                    color="secondary"
                                    variant="outlined"
                                    InputProps={{ sx: { height: "48px", fontSize: "14px" } }}
                                    value={selectedCopyRecord.SO_Condition}
                                    onChange={(e) => setSelectedCopyRecord({
                                        ...selectedCopyRecord,
                                        SO_Condition: e.target.value
                                    })}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <label>Sort</label>
                                <TextField
                                    className="mt-1 w-100"
                                    color="secondary"
                                    variant="outlined"
                                    InputProps={{ sx: { height: "48px", fontSize: "14px" } }}
                                    value={selectedCopyRecord.SO_Sort}
                                    onChange={(e) => setSelectedCopyRecord({
                                        ...selectedCopyRecord,
                                        SO_Sort: e.target.value
                                    })}
                                />
                            </Grid>
                        </Grid>
                        <ButtonTheme type="submit" variant="filled" color="primary" onClick={() => handleCopyRecord(selectedCopyRecord)} className="mt-4">
                            Create
                        </ButtonTheme>
                    </Modal.Body>
                </div>
            </Modal>

            <Modal show={deletModal} onHide={() => setDeleteModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Record</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ color: '#555555' }}>
                        Are you sure to delete this Record?
                    </div>
                    <Row>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setDeleteModal(false)}>
                                Cancel
                            </ButtonTheme>
                        </Col>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={handleDelete}>
                                Delete
                            </ButtonTheme>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ManagePayroll;